import { message } from 'antd'
import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { RESPONSE_MESSAGE } from '../utils/constants'

// วัสดุที่ร้านสร้าง (green2get-app spec 111 Phase 3 · spec 017)

const FETCH_CUSTOM_MATERIAL_REQUEST =
  'materialCustom/FETCH_CUSTOM_MATERIAL_REQUEST'
const FETCH_CUSTOM_MATERIAL_SUCCESS =
  'materialCustom/FETCH_CUSTOM_MATERIAL_SUCCESS'
const FETCH_CUSTOM_MATERIAL_FAILURE =
  'materialCustom/FETCH_CUSTOM_MATERIAL_FAILURE'

export const CUSTOM_SORT = {
  SAME_NAME: 'sameNameShopCount',
  CREATED_AT: 'createdAt'
}

const emptyPage = { content: [], total: 0, page: 0, size: 20 }

// Initialize State
const initialState = {
  isLoading: false,
  error: {},
  customList: emptyPage
}

// Default Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CUSTOM_MATERIAL_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_CUSTOM_MATERIAL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        customList: action.payload
      }
    case FETCH_CUSTOM_MATERIAL_FAILURE:
      return {
        ...state,
        isLoading: false
      }
    default:
      return state
  }
}

const backendMessageOf = (error) =>
  (error.response && error.response.data && error.response.data.message) ||
  RESPONSE_MESSAGE.FAIL

// params: { parentMaterialId, heroId, keyword, sort, page, size } — ค่าที่ว่างไม่ต้องส่ง
export const getCustomMaterialList = (params) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_CUSTOM_MATERIAL_REQUEST
      })

      const response = await API.get(`${EndPoints.MATERAIAL}/customList`, {
        params
      })

      dispatch({
        type: FETCH_CUSTOM_MATERIAL_SUCCESS,
        payload: response.data.data || emptyPage
      })
    } catch (error) {
      message.error(backendMessageOf(error))
      dispatch({
        type: FETCH_CUSTOM_MATERIAL_FAILURE
      })
    }
  }
}

// คืน { success, message } เพื่อให้ modal แสดงเหตุผลของ backend และสรุปผลเมื่อย้ายหลายรายการ
export const updateCustomParent = (id, parentMaterialId) => {
  return async () => {
    try {
      await API.put(`${EndPoints.MATERAIAL}/updateCustomParent`, {
        id,
        parentMaterialId
      })
      return { success: true }
    } catch (error) {
      return { success: false, message: backendMessageOf(error) }
    }
  }
}

export const promoteCustomMaterial = (data) => {
  return async () => {
    try {
      await API.post(`${EndPoints.MATERAIAL}/promoteCustom`, data)
      return { success: true }
    } catch (error) {
      return { success: false, message: backendMessageOf(error) }
    }
  }
}
